export function serializeSearchParameterFields(fields) {
    return fields.map(function (_a) {
        var fieldApiName = _a.fieldApiName, entityType = _a.entityType, fetchEntities = _a.fetchEntities;
        return ({
            fieldId: fieldApiName,
            entityTypeId: entityType,
            shouldFetchEntities: fetchEntities
        });
    });
}
export function serializeExcludedFields(excludedFields) {
    return excludedFields === null || excludedFields === void 0 ? void 0 : excludedFields.map(function (_a) {
        var _b, _c;
        var fieldId = _a.fieldId, matcher = _a.matcher, value = _a.value;
        return (_b = {},
            _b[fieldId] = (_c = {},
                _c[matcher] = value,
                _c),
            _b);
    });
}
//# sourceMappingURL=serializeFilterSearch.js.map